import {useRef, useEffect} from 'react'
import {createTooltipOverlay} from '../tooltip'
import {HOVER_AREA, ICONS} from './constants'
import {prettyPrintArray} from '@eitje/utils'

export const useMarkers = ({isLoaded, mapInstance, groupedEnvironments}) => {
	const markersRef = useRef([])
	const tooltipRef = useRef(null)

	useEffect(() => {
		if (!isLoaded || !window.google || !mapInstance) return
		const {google} = window
		tooltipRef.current ??= createTooltipOverlay(google, mapInstance)

		groupedEnvironments.forEach(({lat, lng, status, environments}) => {
			const title = prettyPrintArray({array: environments._map('naam'), quotes: false, joinWord: '&', sort: true})
			const marker = new google.maps.Marker({
				map: mapInstance,
				position: {lat, lng},
				icon: {url: ICONS[status], anchor: new window.google.maps.Point(HOVER_AREA / 2, HOVER_AREA / 2)},
			})

			marker.addListener('mouseover', () => tooltipRef.current.show(title, {lat, lng}))
			marker.addListener('mouseout', () => tooltipRef.current.hide())

			markersRef.current.push(marker)
		})

		return () => {
			markersRef.current.forEach(marker => marker.setMap(null))
			markersRef.current = []
			tooltipRef.current?.hide()
		}
	}, [isLoaded, mapInstance, groupedEnvironments])

	return {markersRef, tooltipRef}
}
